import styled from "styled-components";
import Th from "./Th";

const Thead = styled.thead`
  ${Th} {
    background-color: ${({ theme }) => theme.colors.gray100};
    border-top: 1px solid ${({ theme }) => theme.colors.gray200};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  }
`;

export default Thead;
